<template>
<Row>
    <i-col span="12">
  <Form ref="formValidate" :model="formValidate"  :label-width="120">
        <FormItem label="订单取消时间" prop="quit_order_time">
            <i-input v-model="formValidate.quit_order_time" placeholder="">
                <span slot="append">分钟</span>
            </i-input>
        </FormItem>
        <FormItem label="iconfont的css的url" prop="iconfont_css">
            <i-input v-model="formValidate.iconfont_css" placeholder=""></i-input>
        </FormItem>
         <FormItem label="平台名称" prop="site_title">
            <i-input v-model="formValidate.site_title" placeholder=""></i-input>
        </FormItem>
         <FormItem label="平台描述" prop="site_desc">
            <i-input v-model="formValidate.site_desc" placeholder=""></i-input>
        </FormItem>
        <FormItem>
            <Button type="primary" @click="settingupdate()">提交</Button>
        </FormItem>
    </Form>
    </i-col>
</Row>
  
</template>
<script>
import { settingupdate } from "../../api/paymethodapi";
import { mapState } from "vuex";
export default {
  data() {
    return {
      // formValidate: {
      //   quit_order_time: "",
      //   iconfont_css: "",
      //   site_title: "",
      //   site_desc: ""
      // }
    };
  },
  computed: {
    ...mapState({
      setting: state => state.setting
    }),
    formValidate(){
      var data={
        quit_order_time: this.setting.quit_order_time,
        iconfont_css: this.setting.iconfont_css,
        site_title: this.setting.site_title,
        site_desc: this.setting.site_desc
      }
      return data
    }

  },
  methods: {
    settingupdate() {
      var par = {};
      if (this.formValidate.quit_order_time&&this.formValidate.quit_order_time!=this.setting.quit_order_time) {
        par.quit_order_time = Number(this.formValidate.quit_order_time);
      }
      if (this.formValidate.iconfont_css&&this.formValidate.iconfont_css!=this.setting.iconfont_css) {
        par.iconfont_css = this.formValidate.iconfont_css;
      }
      if (this.formValidate.site_title&&this.formValidate.site_title!=this.setting.site_title) {
        par.site_title = this.formValidate.site_title;
      }
      if (this.formValidate.site_desc&&this.formValidate.site_desc!=this.setting.site_desc) {
        par.site_desc = this.formValidate.site_desc;
      }
      settingupdate(par).then(res => {
        this.$Loading.finish();
        let data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
        } else {
          self.$Message.error(data.message);
        }
      });
    }
  },
  mounted() {
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/System/setting.vue